import { LegalPage } from "./Legal";

export function Tokushoho() {
  return (
    <LegalPage title="特定商取引法に基づく表記" lastUpdated="2026年9月26日">
      <dl className="grid grid-cols-[7rem_1fr] border-2 border-ink bg-sheet text-[13px] sm:grid-cols-[11rem_1fr] [&>div:last-child>*]:border-b-0">
        <Row label="販売業者" value="株式会社Prescend" />
        <Row label="代表責任者" value="堀田有哉" />
        <Row label="所在地" value="福岡県福岡市中央区天神4丁目6-28 天神ファーストビル7階" />
        <Row label="電話番号" value="請求があった場合に遅滞なく開示いたします" />
        <Row label="メールアドレス" value="hy@prscnd.com" />
        <Row label="販売価格" value="月額 980 円（税込）" />
        <Row label="商品代金以外の必要料金" value="インターネット接続にかかる通信料はお客様の負担となります" />
        <Row label="支払方法" value="クレジットカード（Stripe経由）" />
        <Row label="支払時期" value="申込み時に初回を決済します。以後、申込日を基準に毎月自動で決済します" />
        <Row label="提供時期" value="決済完了後、直ちに利用可能" />
        <Row label="契約期間" value="1 か月単位の自動更新" />
        <Row label="解約方法" value="アプリ右上「アカウント」の「お支払い・解約の管理」からいつでも解約可能です。解約後も現在の請求期間の末日まで利用できます" />
        <Row label="返品・返金" value="デジタルコンテンツの性質上、日割り返金を含め返金は行いません" />
        <Row label="動作環境" value="最新版の Chrome / Safari / Edge / Firefox" />
      </dl>
    </LegalPage>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="contents">
      <dt className="hatch border-r border-b border-ink px-3 py-2.5 text-[12px] font-black">{label}</dt>
      <dd className="border-b border-ink px-3 py-2.5 leading-relaxed">{value}</dd>
    </div>
  );
}
